export const formatMoney = (
  amount: number,
  locale = 'de-DE',
  currency = 'EUR',
  maximumFractionDigits = 0,
  options: Intl.NumberFormatOptions = {}
) =>
  new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    maximumFractionDigits,
    ...options,
    ...(maximumFractionDigits === 0 && { minimumFractionDigits: 0 }),
  }).format(amount)

export const formatPriceAmount = (
  amount: number,
  locale: string,
  currency: string | undefined = undefined,
  maximumFractionDigits = 2,
  options: Intl.NumberFormatOptions = {}
) => formatMoney(amount / 100, locale, currency, maximumFractionDigits, options)
